import { Controller } from "react-hook-form";
import { Input } from "../../../../../components/Input";
import React, {FC} from "react";
import {TextArea} from "../../../../../components/TextArea";
import {POST_BOX_VALUE} from "../../const";

interface Props {
    control: any;
}

const PostFields: FC<Props> = ({control}) => {

    return (
        <>
            <Controller
                render={({ field, fieldState }) => {
                    return (
                        <Input
                            placeholder="Желаемые адреса (город, улица, дом)"
                            {...field}
                            {...fieldState}
                            ref={null}
                        />
                    );
                }}
                name={`${POST_BOX_VALUE}.address`}
                control={control}
            />
            <Controller
                render={({ field, fieldState }) => {
                    return (
                        <TextArea
                            placeholder="Комментарий"
                            {...field}
                            {...fieldState}
                            ref={null}
                        />
                    );
                }}
                name={`${POST_BOX_VALUE}.comment`}
                control={control}
            />
        </>
    );
};

export default PostFields;
